import { HashLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LandingComponent } from 'src/app/components/landing/landing.component';
import { LoginComponent } from 'src/app/components/login/login.component';
import { ErrorComponent } from 'src/app/components/error/error.component';
import { NotfoundComponent } from 'src/app/components/notfound/notfound.component';
import { AccessComponent } from 'src/app/components/access/access.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./layout/app.layout.module').then( m => m.AppLayoutModule)
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: 'logout', loadChildren: () => import('./logout/logout.module').then(rm => rm.LogoutModule) },
  { path: 'prospect-customer-dtls/:prospectId', loadChildren: () => import('./prospect-customer-dtls/prospect-customer-dtls.module').then(rm => rm.ProspectCustomerDtlsModule) },
  { path: 'prospect-payment-dtls/:prospectId', loadChildren: () => import('./prospect-payment-dtls/prospect-payment-dtls.module').then(rm => rm.ProspectPaymentDtlsModule) },
  { path: 'examination-form/:prospectId', loadChildren: () => import('./examination-form/examination-form.module').then(m => m.ExaminationFormModule) },
  { path: 'nomination-form/:prospectId', loadChildren: () => import('./training-nomination-form/nomination-form.module').then(rm => rm.NominationFormModule) },
  { path: 'nomination-form/:flag/:prospectId', loadChildren: () => import('./training-nomination-form/nomination-form.module').then(rm => rm.NominationFormModule) },
  { path: 'feedback-detail/:traineeId', loadChildren: () => import('./training-feedback-detail/feedback-detail.module').then(rm => rm.FeedbackDetailModule) },
  { path: 'resetPassword', loadChildren: () => import('./reset-password/resetPassword.module').then(rm => rm.ResetPasswordModule) },
  { path: 'user-agreement-form/:prospectId', loadChildren: () => import('./user-agreement-form/user-agreement-form.module').then(m => m.UserAgreementFormModule)},
  {path:'pages/landing', component: LandingComponent},
  {path:'pages/login', component: LoginComponent},
  {path:'pages/error', component: ErrorComponent},
  {path:'pages/notfound', component: NotfoundComponent},
  {path:'pages/access', component: AccessComponent},
  {path: '**', redirectTo: 'pages/notfound'},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', anchorScrolling:'enabled' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
